import { useEffect, useMemo, useState } from 'react';

interface UsePaginationProps<T> {
  data: T[];
  rowsPerPage: number;
}

/**
 * Función que permite manejar la paginación de las tablas creadas con HeroUI
 */
export const usePagination = <T>({
  data,
  rowsPerPage,
}: UsePaginationProps<T>) => {
  const [page, setPage] = useState(1);

  const pages = Math.ceil(data.length / rowsPerPage);

  // Reset automático cuando la página actual excede las páginas disponibles
  useEffect(() => {
    if (page > pages && pages > 0) {
      setPage(1);
    }
  }, [pages, page]);

  const items = useMemo(() => {
    const start = (page - 1) * rowsPerPage;
    const end = start + rowsPerPage;

    return data.slice(start, end);
  }, [data, page, rowsPerPage]);

  return { items, page, setPage, pages };
};
